<script>
import { onMount } from "svelte";
import axios from 'axios';
    let fecha = '';
    let hora = '';
    let data = '';
    let doctor='',titulo='',matricula='',firma='',nombre='',cuerpo='',documento='',afiliado='',mutual='';
    export let params;

    onMount(()=>{
        let date = new Date();
        fecha = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
        hora = `${date.getHours()}:${(date.getMinutes()<9? `0${date.getMinutes()}`:date.getMinutes())}`;
        axios.get(`https://vps-1858514-x.dattaweb.com/recetas/${params.id}`,{auth:{username:'demo',password:'demo'}})
        .then((res)=>{
            console.log(res);
            doctor = res.data.doctor;
            titulo = res.data.titulo;
            matricula = res.data.matricula;
            firma = res.data.firma;
            documento = res.data.documento;
            afiliado = res.data.afiliado;
            mutual = res.data.mutual;
            data = res.data.cuerpo;
        })
        .catch((err)=>{
            console.log(err);
        })
    })
</script>

<div class="contenedor">
    
    <div class="carta">
        <div class="fila">
            <div class="nombre">
                <span>{doctor}</span>
            </div>
            <div class="titulo">
                <span>{titulo}</span>
                <span>{matricula}</span>
            </div>
        </div>
        <div class="fila">
            <div class="datos">
                <div class="col"><span>Nombre: </span>{nombre}</div>
                <div class="col"><span>Documento: </span>{documento}</div>
            </div>
            <div class="datos">
                <div class="col"><span>Mutual: </span>{mutual}</div>
                <div class="col"><span>N° Afiliado: </span>{afiliado}</div>
            </div>
        </div>
        <div class="cuerpo">
            <span>RP/ </span>
            <div class="output">{@html data}</div>
        </div>
        <div class="pie">
            <div class="horafecha">
                {fecha} - {hora}Hs.
            </div>
            <div class="firma">
                <img src={firma} alt="f">
                <span>{doctor} - {titulo} - {matricula}</span>
            </div>
        </div>
    </div>


</div>

<style>
    .contenedor{
        display: flex;
        align-items: center;
        justify-items: center;
        width: 100vw;
        max-width: 100%;
        height: 100vh;
        max-height: 100%;
        background: #3e85ff;
    }
    .carta{
        width: 90%;
        max-width: 380px;
        height: 380px;
        background: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(207,215,255,1) 100%);
        color: var(--negro);
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 5px;
        font-size: 12px;
    }
    .nombre{
        width: 50%;
        border-bottom: solid 1px rgba(0,0,0,.1);
        display: flex;
        align-items: center;
        justify-content: center;
        height:50px;
    }
    .titulo{
        width: 50%;
        border-bottom: solid 1px rgba(0,0,0,.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height:50px;
    }
    span{
        font-weight: bold;
    }
    .datos{
        width: 50%;
        height: 100%;
        border-bottom: solid 1px rgba(0,0,0,.1);
    }
    .fila{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    .cuerpo{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 250px;
        padding: 5px;
    }
    .pie{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100px;
    }
    .pie > .firma{
        display: flex;
        align-content: center;
        justify-content: center;
        position: relative;
        width: 50%;
        height: 100px;
    }
    .pie > .horafecha{
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pie > .firma > img {
        width: 100px;
        object-fit: cover;
    }
    .pie > .firma > span{
        border-top: solid 1px rba(0,0,0,.1);
        position: absolute;
        bottom: 0;
        left: 0;
    }
</style>
